import { render, staticRenderFns } from "./indexJs.vue?vue&type=template&id=ca8f1c44&scoped=true"
import script from "./indexJs.vue?vue&type=script&lang=js"
export * from "./indexJs.vue?vue&type=script&lang=js"
import style0 from "./indexJs.vue?vue&type=style&index=0&id=ca8f1c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8f1c44",
  null
  
)

export default component.exports